import React from 'react';
import './index.scss';

const ColorTile = ({ color = 'white', style = {} }) => (
    <div className='ColorTile' style={{ ...style, background: color }} />
);

export default ColorTile;
